import booksInfo from "../../api/books.json";
import { Book } from "./Book";

export const Books = () => (
	<section className="container book">
		{booksInfo.map((book) => (
			<Book
				key={book.id}
				book={book}
			/>
		))}
	</section>
);
